var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrafts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 24,
    height: 24,
    transform: "translate(-23936 -12560)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773",
    transform: "translate(-1775.406 -1863.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_38",
    "data-name": "Mask Group 38",
    transform: "translate(25711.406 14423.999)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "border_color_FILL0_wght400_GRAD0_opsz48",
    d: "M80,200.534v-2.1H98v2.1Zm1.845-4.482v-2.992l8.392-8.393,2.993,2.993-8.393,8.392Zm1.35-1.35h1.013l7.087-7.087L90.282,186.6l-7.088,7.087Zm11.025-8.033-2.992-2.992,1.89-1.89a.764.764,0,0,1,.563-.3.861.861,0,0,1,.63.3l1.755,1.755a.871.871,0,0,1,.292.619.945.945,0,0,1-.247.619ZM83.195,194.7Z",
    transform: "translate(-24013 -12739.419)",
    fill: "#918f90"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafts);
export default __webpack_public_path__ + "static/media/drafts.a82107b6de48be0e419d5657c42243ff.svg";
export { ForwardRef as ReactComponent };